import { privateRequest } from "../axios";

export interface IGeoFenceArea {
  CreateDate: Date | string;
  Id: number;
  Latitude: number;
  Longitude: number;
  Name: string;
  Range: number;
  ModifiedDate?: Date | string;
  IsActive?: boolean;
  CreateBy?: number;
  ModifiedBy?: number;
  CompanyId?: number;
  GeoFenceTypeId?: number;
}

export interface IGeoFenceType {
  Id: number;
  Name: string;
}

const ENDPOINTS = {
  GEO_FENCE_AREA: "api/GetGeoFencingArea",
  GEO_FENCE_TYPES: "api/GeoFenceTypes",
  Add_NEW_GEO_FENCE_AREA: "api/AddGeoFencing",
  REMOVE_GEO_FENCE_AREA: "api/RemoveGeoFencing",
  UPDATE_GEO_FENCE_AREA: "api/UpdateGeoFencing",
  DELETE_HOLIDAY: "api/DeleteFestival",
  ADD_HOLIDAY: "api/AddFestival",
  WORKSTATION: "api/WorkStation",
  UPDATE_GLOBAL_SETTING: "api/GC/GlobalSetting",
  CHANGE_DEVICE_MAIL_SETTING: "api/ChangeDeviceNotificationSetting",
  CHANGE_DEVICE_SETTING: "api/ChangeDeviceSetting",
  TIMESHEET_APPROVERS: "api/Timesheet/Approvers",
  TIMESHEET_APPROVER: "api/Timesheet/Approver",
  DEFAULT_TIMESHEET_APPROVER : "api/Timesheet/DefaultApprovers",
  DEFAULT_TIMESHEET_REVIEWERS : "api/Timesheet/Reviewers",
  TIME_SHEET_APPROVER_SETTINGS : "api/TimesheetSetting",
  TIME_SHEET_APPROVER : "api/Timesheet/DefaultApprover",
  TIME_SHEET_REVIEWER : "api/Timesheet/Reviewer",
  TIME_SHEET_NOTIFY_TEAM_MEMBER : "api/TimesheetUser",
  TIME_SHEET_TEAM_MEMBER : "api/TimesheetTeamMembers",
  TIME_SHEET_BULK_ADD_REMOVE : "api/Timesheet/v1/SetTimesheetStatusApprovalMapping",
};

export const DEFAULT_MUMBAI_CORDINATES = { lat: 19.076, lng: 72.8777 };

export function formatDateReadable(dateStr: string): string {
  const [month, day, yearRaw] = dateStr.split("/").map(Number);
  const year = yearRaw && yearRaw < 100 ? 2000 + yearRaw : yearRaw;

  const date = new Date(year!, month! - 1, day);

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const getOrdinal = (n: number) => {
    if (n > 3 && n < 21) return `${n}th`;
    switch (n % 10) {
      case 1:
        return `${n}st`;
      case 2:
        return `${n}nd`;
      case 3:
        return `${n}rd`;
      default:
        return `${n}th`;
    }
  };

  return `${getOrdinal(day!)} ${months[date.getMonth()]} ${year} ${days[date.getDay()]}`;
}

export const getGeoFenceAreaNameById = (
  geoFenceTypes: IGeoFenceType[],
  id: number | undefined,
) => {
  const type = geoFenceTypes.find((type: any) => type.Id === id);
  return type?.Name;
};

export const fetchGeoFenceAreas = async (): Promise<any> => {
  const response = await privateRequest.get(ENDPOINTS.GEO_FENCE_AREA);
  return response.data;
};

export const fetchWorkStation = async (): Promise<any> => {
  const response = await privateRequest.get(
    `${ENDPOINTS.WORKSTATION}?From=1&To=-1&Search=&IsActive=true`,
  );
  return response.data;
};

export const addNewWorkStation = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.WORKSTATION, payload);
  return response.data;
};

export const editWorkStation = async (
  id: number,
  payload: any,
): Promise<any> => {
  const response = await privateRequest.put(
    `${ENDPOINTS.WORKSTATION}/${id}`,
    payload,
  );
  return response.data;
};

export const removeWorkstation = async (id: number) => {
  const res = await privateRequest.delete(`${ENDPOINTS.WORKSTATION}/${id}`);
  return res.data;
};

export const fetchGeoFenceTypes = async (): Promise<any> => {
  const response = await privateRequest.get(ENDPOINTS.GEO_FENCE_TYPES);
  return response.data;
};

export const addNewAttendanceGeoFenceArea = async (
  payload: any,
): Promise<any> => {
  const response = await privateRequest.post(
    ENDPOINTS.Add_NEW_GEO_FENCE_AREA,
    payload,
  );
  return response.data;
};

export const updateAttendanceGeoFenceArea = async (
  payload: any,
): Promise<any> => {
  const response = await privateRequest.post(
    ENDPOINTS.UPDATE_GEO_FENCE_AREA,
    payload,
  );
  return response.data;
};

export const removeAttendanceGeoFenceArea = async (
  id: number,
): Promise<any> => {
  const response = await privateRequest.get(
    `${ENDPOINTS.REMOVE_GEO_FENCE_AREA}?Id=${id}`,
  );
  return response.data;
};

export const removeHoliday = async (id: number): Promise<any> => {
  const response = await privateRequest.get(
    `${ENDPOINTS.DELETE_HOLIDAY}?HolidayId=${id}`,
  );
  return response.data;
};

export const addNewHoliday = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.ADD_HOLIDAY, payload);
  return response.data;
};

export const editGlobalSetting = async (data: any): Promise<any> => {
  const res = await privateRequest.put(ENDPOINTS.UPDATE_GLOBAL_SETTING, data);
  return res.data;
};

export const fetchChangeDeviceMailSettings = async (): Promise<any> => {
  const response = await privateRequest.get(ENDPOINTS.CHANGE_DEVICE_MAIL_SETTING);
  return response.data;
};

export const addChangeDeviceMailSettings = async (Ids: string): Promise<any> => {
  const response = await privateRequest.post(`${ENDPOINTS.CHANGE_DEVICE_MAIL_SETTING}?userIds=${Ids}`,);
  return response.data;
};

export const removeChangeDeviceMailSetting = async (id: number): Promise<any> => {
  const response = await privateRequest.delete(`${ENDPOINTS.CHANGE_DEVICE_MAIL_SETTING}?userId=${id}`);
  return response.data;
};

export const fetchChangeDeviceSetting = async (): Promise<any> => {
  const response = await privateRequest.get(ENDPOINTS.CHANGE_DEVICE_SETTING);
  return response.data;
};

export const updateChangeDeviceSetting = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.CHANGE_DEVICE_SETTING, payload);
  return response.data;
};

export const fetchTimesheetApprovers = async (params: any): Promise<any> => {
  const response = await privateRequest.get(ENDPOINTS.TIMESHEET_APPROVERS, { params });
  return response.data;
};

export const postTimesheetApprovers = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.TIMESHEET_APPROVERS, payload);
  return response.data;
};

export const removeTimesheetApprover = async (payload: { leaveUserId: number; approverId: number; approvalOrder: number }): Promise<any> => {
  const response = await privateRequest.put(
    `${ENDPOINTS.TIMESHEET_APPROVER}?timesheetUserId=${payload.leaveUserId}&approverId=${payload.approverId}&approvalOrder=${payload.approvalOrder}`
  );
  return response.data;
};

export const getDefaultTimeSheetApprover = async (): Promise<any> => {
  const response = await privateRequest.get(ENDPOINTS.DEFAULT_TIMESHEET_APPROVER);
  return response.data;
};

export const getDefaultTimeSheetReviewers = async (): Promise<any> => {
  const response = await privateRequest.get(ENDPOINTS.DEFAULT_TIMESHEET_REVIEWERS);
  return response.data;
};

export const getTimeSheetSettings = async() : Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.TIME_SHEET_APPROVER_SETTINGS);
  return res.data;
}

export const getTimeSheetApproverSetting = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.TIME_SHEET_APPROVER_SETTINGS);
  return res.data;
};

export const updateTimeSheetSettings = async(payload: any) : Promise<any> => {
  const res = await privateRequest.post(ENDPOINTS.TIME_SHEET_APPROVER_SETTINGS, payload);
  return res.data;
}

export const deleteDefaultTimeSheetApprover = async(id : number) : Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.TIME_SHEET_APPROVER}?approverId=${id}`);
  return res.data;
}

export const deleteTimeSheetReviewer = async(id : number) : Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.TIME_SHEET_REVIEWER}/${id}`)
  return res.data;
}

export const addDefaultTimesheetApprovers = async (payload: { UserId: number }[]): Promise<any> => {
  const res = await privateRequest.post<any>(ENDPOINTS.TIME_SHEET_APPROVER, payload);
  return res.data;
};

export const addTimesheetReviewers = async (payload: { UserId: number }[]): Promise<any> => {
  const res = await privateRequest.post<any>(ENDPOINTS.TIME_SHEET_REVIEWER, payload);
  return res.data;
};

export const getTimeSheetTeamMember = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.TIME_SHEET_NOTIFY_TEAM_MEMBER);
  return res.data;
};

export const deleteTimeSheetMember = async(id : number) : Promise<any> => {
  const res = await privateRequest.delete(`${ENDPOINTS.TIME_SHEET_NOTIFY_TEAM_MEMBER}?userId=${id}`);
  return res.data;
}

export const addTeamMembers = async (userIds: string): Promise<any> => {
  const res = await privateRequest.post(`${ENDPOINTS.TIME_SHEET_NOTIFY_TEAM_MEMBER}?userIds=${userIds}`);
  return res.data;
};

export const getTimeSheetMember = async() : Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.TIME_SHEET_TEAM_MEMBER);
  return res.data;
}

export const addBulkTimesheetApprover = async (payload: any): Promise<any> => {
  const res = await privateRequest.post(ENDPOINTS.TIME_SHEET_BULK_ADD_REMOVE, payload);
  return res.data;
} 